export const bitcoinHistoricalMonthly = [
    { date: "Apr 2026", price: "71364" },
    { date: "Mar 2026", price: "67217" },
    { date: "Feb 2026", price: "70682" },
    { date: "Jan 2026", price: "90617" },
    { date: "Dec 2025", price: "88458" },
    { date: "Nov 2025", price: "104489" },
    { date: "Oct 2025", price: "115023" },
    { date: "Sep 2025", price: "115853" },
    { date: "Aug 2025", price: "118331" },
    { date: "Jul 2025", price: "119123" },
    { date: "Jun 2025", price: "105133" },
    { date: "May 2025", price: "103744" },
    { date: "Apr 2025", price: "94207" },
    { date: "Mar 2025", price: "71417" },
    { date: "Feb 2025", price: "67840" },
    { date: "Jan 2025", price: "61186" },
    { date: "Dec 2024", price: "56461" },
    { date: "Nov 2024", price: "51641" },
    { date: "Oct 2024", price: "51300" },
    { date: "Sep 2024", price: "50295" },
    { date: "Aug 2024", price: "44112" },
    { date: "Jul 2024", price: "43754" },
    { date: "Jun 2024", price: "40845" },
    { date: "May 2024", price: "42351" },
    { date: "Apr 2024", price: "42865" },
    { date: "Mar 2024", price: "45138" },
    { date: "Feb 2024", price: "47795" },
    { date: "Jan 2024", price: "43499" },
    { date: "Dec 2023", price: "42101" },
    { date: "Nov 2023", price: "37325" },
    { date: "Oct 2023", price: "34008" },
    { date: "Sep 2023", price: "26773" },
    { date: "Aug 2023", price: "26061" },
    { date: "Jul 2023", price: "29153" },
    { date: "Jun 2023", price: "30469" },
    { date: "May 2023", price: "27079" },
    { date: "Apr 2023", price: "29268" },
    { date: "Mar 2023", price: "28477" },
    { date: "Feb 2023", price: "23723" },
    { date: "Jan 2023", price: "22961" },
    { date: "Dec 2022", price: "16547" },
    { date: "Nov 2022", price: "17154" },
    { date: "Oct 2022", price: "20495" },
    { date: "Sep 2022", price: "19431" },
    { date: "Aug 2022", price: "20049" },
    { date: "Jul 2022", price: "23336" },
    { date: "Jun 2022", price: "19784" },
    { date: "May 2022", price: "31792" },
    { date: "Apr 2022", price: "37714" },
    { date: "Mar 2022", price: "45538" },
    { date: "Feb 2022", price: "43193" },
    { date: "Jan 2022", price: "38483" },
    { date: "Dec 2021", price: "46306" },
    { date: "Nov 2021", price: "57005" },
    { date: "Oct 2021", price: "61318" },
    { date: "Sep 2021", price: "43790" },
    { date: "Aug 2021", price: "47166" },
    { date: "Jul 2021", price: "41626" },
    { date: "Jun 2021", price: "35040" },
    { date: "May 2021", price: "37332" },
    { date: "Apr 2021", price: "57750" },
    { date: "Mar 2021", price: "58918" },
    { date: "Feb 2021", price: "45137" },
    { date: "Jan 2021", price: "33114" },
    { date: "Dec 2020", price: "29001" },
    { date: "Nov 2020", price: "19625" },
    { date: "Oct 2020", price: "13781" },
    { date: "Sep 2020", price: "10784" },
    { date: "Aug 2020", price: "11680" },
    { date: "Jul 2020", price: "11323" },
    { date: "Jun 2020", price: "9137" },
    { date: "May 2020", price: "9461" },
    { date: "Apr 2020", price: "8658" },
    { date: "Mar 2020", price: "6438" },
    { date: "Feb 2020", price: "8599" },
    { date: "Jan 2020", price: "9350" },
    { date: "Dec 2019", price: "7193" },
    { date: "Nov 2019", price: "7569" },
    { date: "Oct 2019", price: "9199" },
    { date: "Sep 2019", price: "8293" },
    { date: "Aug 2019", price: "9630" },
    { date: "Jul 2019", price: "10085" },
    { date: "Jun 2019", price: "10817" },
    { date: "May 2019", price: "8574" },
    { date: "Apr 2019", price: "5350" },
    { date: "Mar 2019", price: "4105" },
    { date: "Feb 2019", price: "3854" },
    { date: "Jan 2019", price: "3457" },
    { date: "Dec 2018", price: "3742" },
    { date: "Nov 2018", price: "4017" },
    { date: "Oct 2018", price: "6317" },
    { date: "Sep 2018", price: "6625" },
    { date: "Aug 2018", price: "7037" },
    { date: "Jul 2018", price: "7780" },
    { date: "Jun 2018", price: "6404" },
    { date: "May 2018", price: "7494" },
    { date: "Apr 2018", price: "9240" },
    { date: "Mar 2018", price: "6973" },
    { date: "Feb 2018", price: "10397" },
    { date: "Jan 2018", price: "10221" },
    { date: "Dec 2017", price: "14156" },
    { date: "Nov 2017", price: "10233" },
    { date: "Oct 2017", price: "6468" },
    { date: "Sep 2017", price: "4338" },
    { date: "Aug 2017", price: "4703" },
    { date: "Jul 2017", price: "2875" },
    { date: "Jun 2017", price: "2480" },
    { date: "May 2017", price: "2286" },
    { date: "Apr 2017", price: "1347" },
    { date: "Mar 2017", price: "1071" },
    { date: "Feb 2017", price: "1179" },
    { date: "Jan 2017", price: "970" },
    { date: "Dec 2016", price: "963" },
    { date: "Nov 2016", price: "745" },
    { date: "Oct 2016", price: "700" },
    { date: "Sep 2016", price: "609" },
    { date: "Aug 2016", price: "575" },
    { date: "Jul 2016", price: "624" },
    { date: "Jun 2016", price: "673" },
    { date: "May 2016", price: "531" },
    { date: "Apr 2016", price: "448" },
    { date: "Mar 2016", price: "416" },
    { date: "Feb 2016", price: "437" },
    { date: "Jan 2016", price: "368" }
];